angular.module('gym.waivers', ['textAngular']).constant('WAIVERS_MERGE_TAG_LIST', ['First Name', 'Last Name', 'Full Name', 'Full Address', 'Current Date']).constant('WAIVERS_COMPLETE_PAGE_TAG_LIST', ['waiver-phone-number', 'waiver-email', 'waiver-business-name']).constant('WAIVERS_COMPLETE_RECEIPT_TAG_LIST', ['waiver-name', 'contact-full-name']).constant('WAIVERS_APPROVE_RECEIPT_TAG_LIST', ['signed-waiver-link']).constant('WAIVER_PREFILLED_INVITE_EMAIL_TAG_LIST', ['prefilled-waiver-link']).config(["$stateProvider", "$provide", "WAIVERS_MERGE_TAG_LIST", "WAIVERS_COMPLETE_PAGE_TAG_LIST", "WAIVERS_COMPLETE_RECEIPT_TAG_LIST", "WAIVERS_APPROVE_RECEIPT_TAG_LIST", "WAIVER_PREFILLED_INVITE_EMAIL_TAG_LIST", function($stateProvider, $provide, WAIVERS_MERGE_TAG_LIST, WAIVERS_COMPLETE_PAGE_TAG_LIST, WAIVERS_COMPLETE_RECEIPT_TAG_LIST, WAIVERS_APPROVE_RECEIPT_TAG_LIST, WAIVER_PREFILLED_INVITE_EMAIL_TAG_LIST) {
  $stateProvider.state('gym.waivers', {
    url: '/waivers',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.waivers.optIn', {
    url: '/waivers/toggle',
    controller: 'WaiversOptInCtrl',
    template: require('templates/gyms/waivers/toggle.html.slim')
  }).state('gym.waivers.list', {
    url: '/waivers',
    template: require('templates/gyms/waivers/list.html.slim')
  }).state('gym.waivers.new', {
    url: '/waivers/new',
    controller: 'WaiverEditCtrl',
    template: require('templates/gyms/waivers/waiver/edit.html.slim'),
    resolve: {
      waiver: ["Waivers", function(Waivers) {
        return Waivers.get('new');
      }],
      membershipPlans: ["MembershipPlans", function(MembershipPlans) {
        return MembershipPlans.getList({
          count: 400
        });
      }]
    }
  }).state('gym.waivers.edit', {
    url: '/waivers/:waiverId/edit',
    controller: 'WaiverEditCtrl',
    template: require('templates/gyms/waivers/waiver/edit.html.slim'),
    resolve: {
      waiver: ["$stateParams", "Waivers", function($stateParams, Waivers) {
        return Waivers.get($stateParams.waiverId);
      }],
      membershipPlans: ["MembershipPlans", function(MembershipPlans) {
        return MembershipPlans.getList({
          count: 400
        });
      }]
    }
  }).state('gym.waivers.waiverSignedWaivers', {
    url: '/waivers/:waiverId/signed_waivers',
    template: require('templates/gyms/waivers/waiver/signed_waivers_list.html.slim')
  }).state('gym.waivers.signedWaivers', {
    url: '/signed_waivers',
    template: require('templates/gyms/waivers/signed_waivers_list.html.slim')
  }).state('gym.waivers.archivedWaivers', {
    url: '/waivers/archived_list',
    template: require('templates/gyms/waivers/archived_list.html.slim')
  }).state('gym.waivers.reviews', {
    url: '/reviews',
    template: require('templates/gyms/waivers/review/list.html.slim')
  }).state('gym.waivers.review', {
    url: '/reviews/new?signed_waiver_id',
    controller: 'WaiverReviewCtrl',
    template: require('templates/gyms/waivers/review/review.html.slim'),
    resolve: {
      waiver: ["$stateParams", "WaiverReviews", function($stateParams, WaiverReviews) {
        return WaiverReviews.get('new', {
          signed_waiver_id: $stateParams.signed_waiver_id
        });
      }],
      membershipPlans: ["MembershipPlans", "waiver", function(MembershipPlans, waiver) {
        if (waiver.signed_waiver_attributes.signed_waiver_form_attributes.membership_options_active) {
          return MembershipPlans.getList({
            count: 400,
            'sorting[custom]': 'asc',
            slim: 1
          });
        } else {
          return [];
        }
      }]
    }
  }).state('gym.waivers.merge', {
    url: '/merges/new?signed_waiver_id',
    controller: 'MergeWaiverCtrl',
    template: require('templates/gyms/waivers/merges/new.html.slim'),
    resolve: {
      waiver: ["$stateParams", "WaiverReviews", function($stateParams, WaiverReviews) {
        return WaiverReviews.get('new', {
          signed_waiver_id: $stateParams.signed_waiver_id
        });
      }],
      waiverMerge: ["$stateParams", "WaiverMerges", function($stateParams, WaiverMerges) {
        return WaiverMerges.get('new', {
          signed_waiver_id: $stateParams.signed_waiver_id
        });
      }]
    }
  }).state('gym.waivers.newBulkInvite', {
    url: '/bulk_invites/new',
    template: require('templates/gyms/waivers/new_bulk_invite.html.slim')
  });
  return $provide.decorator("taOptions", ["taRegisterTool", "$delegate", function(taRegisterTool, $delegate) {
    var registerTool;
    registerTool = function(name) {
      return taRegisterTool(`${name}`, {
        buttontext: `${name}`,
        action: function() {
          var tag;
          tag = `<mark>{${name}}</mark>&#160;`;
          if (window.navigator.userAgent.indexOf('Firefox') >= 0) {
            tag = tag + ' ';
          }
          return this.$editor().wrapSelection("inserthtml", tag);
        }
      });
    };
    WAIVERS_MERGE_TAG_LIST.forEach(registerTool);
    WAIVERS_COMPLETE_PAGE_TAG_LIST.forEach(registerTool);
    WAIVERS_COMPLETE_RECEIPT_TAG_LIST.forEach(registerTool);
    WAIVERS_APPROVE_RECEIPT_TAG_LIST.forEach(registerTool);
    WAIVER_PREFILLED_INVITE_EMAIL_TAG_LIST.forEach(registerTool);
    return $delegate;
  }]);
}]);
